import { twMerge } from "tailwind-merge";
import { clsx } from "clsx";
function cn(...n) {
	return twMerge(clsx(n));
}
export { cn as t };
